import axios from "axios";
import env from "../data/env";

const Token = axios.create({
  baseURL: env.API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const clearAuthStorage = () => {
  localStorage.removeItem("verified");
  localStorage.removeItem("remember_me");
  localStorage.removeItem("user");
};

// Ensure CSRF cookie is set before making authenticated requests.
// Sanctum serves GET {BACKEND_URL}/sanctum/csrf-cookie (web middleware) and
// sets the encrypted XSRF-TOKEN cookie, which axios then echoes back as the
// X-XSRF-TOKEN header (withXSRFToken: true).
export const ensureCsrfCookie = async () => {
  try {
    await axios.get(`${env.BASE_URL}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });
    console.log("✅ CSRF cookie fetched successfully");
  } catch (error) {
    console.error("❌ Failed to fetch CSRF cookie:", error);
    throw error;
  }
};

Token.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config = {} } = error;

    if (response?.status === 401) {
      const requestUrl = config.url || "";
      const isLoginRequest = requestUrl.includes("auth/login");
      const hasAuthMarker = Boolean(localStorage.getItem("verified"));
      const isLoginPage = ["/", "/login"].includes(window.location.pathname);

      // A guest request (including /auth/login with invalid credentials) is
      // not an expired session. Leave the error for the calling component.
      // Only redirect when an existing authenticated session has expired.
      if (!isLoginRequest && hasAuthMarker && !isLoginPage) {
        clearAuthStorage();
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default Token;
